import { endOfDay, format, startOfDay } from 'date-fns';

const ISO_WITH_MS = "yyyy-MM-dd'T'HH:mm:ss.SSSxxx";
const DISPLAY_DATE = 'dd/MM/yyyy';

export const startOfDayISO = (date) => format(startOfDay(date), ISO_WITH_MS);

export const endOfDayISO = (date) => format(endOfDay(date), ISO_WITH_MS);

export const formatDateRangeLabel = (createdAfter, createdBefore) => {
  const from = createdAfter ? format(new Date(createdAfter), DISPLAY_DATE) : '';
  const to = createdBefore ? format(new Date(createdBefore), DISPLAY_DATE) : '';

  if (from && to) {
    return from === to ? from : `${from} - ${to}`;
  }

  if (from) {
    return `From ${from}`;
  }

  return to ? `Until ${to}` : '';
};
